import styled from "styled-components";
import { Color, ColorDark, Font, breakpoints } from "@/shared/Constants";

export const CompatibilityResultContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  color: ${Color.black000};
  margin-bottom: 5px;
  margin-top: 40px;
  ${breakpoints.phone} {
    align-items: flex-start;
  }
  .selected-signs-container {
    display: flex;
    align-items: center;
    ${breakpoints.phone} {
      justify-content: center;
      width: 100%;
    }
  }

  .sign-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .circle {
    width: 105px;
    height: 105px;
    border-radius: 50%;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    color: #333;
    border: 2px solid transparent;
    overflow: hidden;
  }

  .red-circle {
    border: 2px solid #d3d1d1;
  }

  .circle img {
    width: 95px;
    height: 95px;
    object-fit: contain;
  }

  .sign-name {
    margin-top: 8px;
    text-align: center;
    ${Font.sansBold}
    font-size: 28px;
    line-height: 24px;
    ${breakpoints.phone} {
      margin-top: 15px;
    }
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }

  .sign-date {
    ${Font.sansLight}
    font-size: 16px;
    line-height: 20px;
    margin-top: 10px;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }

  .plus {
    margin: 0 15px;
  }

  .text-result-compatibility {
    width: 60%;

    margin-bottom: 35px;
    ${breakpoints.phone} {
      font-size: 21px;
      line-height: 30px;
      width: 100%;
      text-align: left;
      margin-bottom: 0;
    }
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
    p {
      ${Font.clarinVarSub2Light}
      font-size: 23px;
      line-height: 33px;
      text-align: center;
      margin-bottom: 15px;
      ${breakpoints.phone} {
        font-size: 21px;
        line-height: 30px;
        text-align: left;
      }
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
  }

  .text-result-share {
    .SocialMedia {
      padding-bottom: 0;
      ${breakpoints.phone} {
        border-top: none;
        padding-top: 0;
        margin-bottom: 50px;
      }
    }
  }
`;
